import React, { useEffect } from "react";
import { Switch, Redirect, useHistory, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import isTokenValid from "../utils/isTokenValid"; // Import the utility function
import ProtectedRoute from "./ProtectedRoute";
import { logout } from "../redux/auth/actions";
import Companies from "../components/pages/Company";
import Dashboard from "../components/pages/Dashboard";
import Machines from "../components/pages/Machines";
import Users from "../components/pages/Users";
import Machine from "../components/pages/Machines/Machine";
import Event from "../components/pages/Events";
import Session from "../components/pages/Sessions";
import Capabilities from "../components/pages/Capabilities";
import Roles from "../components/pages/Roles";
import Overrides from "../components/pages/Overrides";
import Resources from "../components/pages/Resources";
import EventDetails from "../components/pages/Events/EventDetails";
import Configurations from "../components/pages/Configurations";
import AddConfiguration from "../components/pages/Configurations/AddConfiguration";
import EditConfiguration from "../components/pages/Configurations/AddConfiguration";
import LoginForm from "../login/loginForm";
import CountriesList from "../components/pages/Country/CountriesList";
import ImageUploader from "../components/pages/Pictures/Upload";

// List of roles
const ROLES = {
  SYSTEM_SUPER_ADMIN: "system_super_admin",
  SYSTEM_ADMIN: "system_admin",
  COUNTRY_SUPER_ADMIN: "country_super_admin",
  COMPANY_SUPER_ADMIN: "company_super_admin",
  ORGANISATOR: "organisator",
  CLIENT_REPRESENTATIVE: "client_representative",
  CLIENT: "client",
};

const Routes = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const roleName = user.override ? user.override.name : user.role.name;

  useEffect(() => {
    if (!isTokenValid()) {
      dispatch(logout());
      history.push("/login");
    }
  }, [dispatch, history]);

  return (
    <Switch>
      <Route component={Dashboard} exact path="/" />
      <ProtectedRoute
        component={Dashboard}
        path="/dashboard"
        requiredResource="dashboard"
        
      />
      <ProtectedRoute
        component={ImageUploader}
        path="/upload-pictures"
        requiredResource="all"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={CountriesList}
        path="/country"
        requiredResource="country"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,

        ]}
      />
      <ProtectedRoute
        component={Machines}
        path="/machines"
        requiredResource="machines"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={Machine}
        path="/machine/:_id"
        requiredResource="machines"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={Users}
        path="/users"
        requiredResource="users"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={Companies}
        path="/company"
        requiredResource="company"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,

        ]}
      />
      <ProtectedRoute
        component={Event}
        path="/events"
        requiredResource="events"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
        ]}
      />
      <ProtectedRoute
        component={Session}
        path="/sessions"
        requiredResource="sessions"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={Resources}
        path="/resources"
        requiredResource="resources"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={Capabilities}
        path="/capabilities"
        requiredResource="capabilities"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={Overrides}
        path="/overrides"
        requiredResource="overrides"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={Configurations}
        path="/configurations"
        requiredResource="configurations"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={AddConfiguration}
        exact
        path="/configuration/new"
        requiredResource="configurations"
        requiredCapability="create"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={EditConfiguration}
        exact
        path="/configuration/:_id"
        requiredResource="configurations"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        component={Roles}
        path="/roles"
        requiredResource="roles"
        requiredCapability="create"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.SYSTEM_ADMIN,
          ROLES.COUNTRY_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
          ROLES.CLIENT,
          ROLES.CLIENT_REPRESENTATIVE,
        ]}
      />
      <ProtectedRoute
        path="/event/:_id"
        component={EventDetails}
        requiredResource="events"
        requiredRoles={[
          ROLES.SYSTEM_SUPER_ADMIN,
          ROLES.COMPANY_SUPER_ADMIN,
          ROLES.ORGANISATOR,
        ]}
      />
      <Route path="/login" component={LoginForm} />
      <Redirect to="/" />
    </Switch>
  );
};

export default Routes;
